<div class="ig-bulk-ai-descriptions-modal confirm-modal ig-modal"
    [class.ig-bulk-ai-description-modal-processing]="isCornerView"
    [class.ig-border-spinner]="isCornerView&&progress>=100"
    [ngStyle]="{'width':progress>=100?'275px!important':'200px!important'}">
    <div *ngIf="!isCornerView" style="height:calc(100% - 32px)">
        <div class="close-button" (click)="close()">
            x
        </div>
        <h3 class="title">BULK DESCRIPTION GENERATION</h3>

        <div class="edit-wrap">
            <div class="flex title-row">
                <p *ngIf="progress<=0">Places without description</p>
                <p *ngIf="progress>=100" style="width:35%;text-align:left">Places descriptions generated!</p>
                <p *ngIf="progress>0&&progress<100" style="width:35%;text-align:left">Generating descriptions
                    ({{displayProgress}}) ...
                    <mat-icon class="ig-spin" style="font-size:16px;width:16px;height:16px">autorenew</mat-icon>
                </p>
                <p *ngIf="progress>1" style="color:gray;font-weight:normal;margin-left:13px">Edit descriptions below</p>
            </div>
            <div class="place-wrap text-left">
                <div *ngIf="!places.length">
                    <p>No places without description</p>
                </div>
                <div *ngFor="let place of places;let i = index" class="flex gap-2 p-r-2 relative"
                    [class.ai-processing-row]="progress>1">
                    <div [ngStyle]="{'width':progress>0?'35%':'100%'}" class="text-left">{{i + 1}}. {{place.name}}</div>
                    <div class="absolute" *ngIf="place.description==='NOT FOUND'" style="left:33.5%">
                        <div class="ig-bulk-ai-description-tooltip">
                            <mat-icon>info</mat-icon>
                            <span class="tooltiptext">We can't find any information about this place. You can try again
                                later or edit the description manually</span>
                        </div>
                    </div>
                    <div *ngIf="place.description" style="width:65%;overflow:auto" class="relative m-l-3"
                        [ngStyle]="{'height':place.description==='NOT FOUND'?'26px':'120px'}">
                        <textarea #descriptionTextarea matInput placeholder="Description" type="textArea"
                            [class.red-text]="place.description==='NOT FOUND'" class="transition-50 full-height"
                            [(ngModel)]="place.description">
                        </textarea>
                    </div>
                </div>
            </div>
        </div>

        <div class="action-btns">
            <ig-button *ngIf="progress===0&&places.length" class="btn-primary" #confirmButton color="primary" size="md"
                [isAsync]="true" (trigger)="confirm($event)">
                Generate descriptions for these places
            </ig-button>
            <ig-button *ngIf="progress>=100" class="btn-primary" color="primary" size="md" [isAsync]="true"
                (trigger)="save($event)">
                Save
            </ig-button>
            <div *ngIf="progress>0&&progress<100" class="cancel-btn" style="background-color:lightgray;padding:0 16px;"
                (click)="askForCancel()">
                CANCEL GENERATING
            </div>
            <div *ngIf="progress>0&&progress<100" class="cancel-btn" (click)="isCornerView=true;cdRef.detectChanges()">
                COLLAPSE
            </div>
        </div>

        <div *ngIf="isAskForCancel" class="ig-bulk-ai-descriptions-cancel">
            <p class="flex gap-2 item-center text-left"><mat-icon style="color:red">warning</mat-icon>
                Are you sure you want to cancel the generating of descriptions?</p>
            <div class="flex gap-2 justify-center m-t-2">
                <button (click)="cancel()">Yes</button>
                <button (click)="isAskForCancel=false;cdRef.detectChanges()">No</button>
            </div>
        </div>
    </div>

    <div *ngIf="isCornerView" class="flex gap-2 items-center justify-center pointer"
        [class.ig-bulk-generated]="progress>=100" (click)="checkStatus()">
        <div *ngIf="progress<100" class="m-b-2">
            <div class="flex gap-2 items-center m-b-1">
                <img src="https://iti-images.s3.amazonaws.com/imgs/ai-star.gif" alt="" width="20">
                <p>Generating descriptions...</p>
            </div>
            <mat-progress-bar class="example-margin" [color]="'primary'" [mode]="'determinate'" [value]="progress">
            </mat-progress-bar>
        </div>
        <div *ngIf="progress>=100" class="flex items-center justify-center gap-2">
            <mat-icon style="color:green">check</mat-icon>
            Description generated, please review!
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/bulk.ai.descriptions.modal/bulk.ai.descriptions.modal.component.html